
<template>
  <div id="form-container-requirement" ref="formContainer">
    <h2>Manage Attachment Requirement Settings</h2>

    <b-row class="mt-3">
      <b-col cols="12" lg="6">
        <b-form-group
            label="Request Status" label-for="status-select"
            invalid-feedback="Request Status is required">
          <b-form-select
              aria-label="Please select a request status"
              v-model="requestItem.status"
              style="text-align: center;"
          >
            <option :value="null" disabled>-- Please select an option --</option>
            <option v-for="(item, index) in requestOptions.statuses" :key="index" :value="item" :label="item.description">
              {{ item.description }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col cols="12" lg="6">
        <b-form-group
            label="Request Type" label-for="type-select"
            invalid-feedback="Request Type is required">
          <b-form-select
              aria-label="Please select a request type"
              v-model="requestItem.type"
              style="text-align: center;"
          >
            <option :value="null" disabled>-- Please select an option --</option>
            <option v-for="(item, index) in requestOptions.types" :key="index" :value="item" :label="item.description">
              {{ item.description }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button type="button" variant="primary" :disabled="!requestItem.type || !requestItem.status" @click="loadAttachmentReqs">
          <b-spinner small v-show="loading" class="mr-2"></b-spinner>
          Submit
        </b-button>
      </b-col>
    </b-row>

    <div>
      <hr/>
      <b-button variant="primary"
                class="mt-3"
                v-b-modal.modal-crud
                :disabled="otherAttachmentTypes.length<1"
      >New Requirement
      </b-button>
    </div>

    <b-modal id="modal-crud" :no-close-on-backdrop="true" hide-header hide-footer>
      <h2 v-if="attachmentReqs.length > 0">{{requestItem.type.description}} Requirement</h2>
      <hr/>

      <form ref="form">
        <b-form-group
            label="Attachment Type" label-for="name-input"
            invalid-feedback="Requirement Description is required">
          <b-form-select
              v-if="editedIndex == -1"
              id="name-input"
              v-model="editedItem.attachmentTypeValue"
              required
          >
            <option v-for="(item, index) in otherAttachmentTypes" :key="index" :value="item">
              {{ item.description }}
            </option>
          </b-form-select>

          <b-form-input
              v-if="editedIndex > -1"
              id="code-input"
              v-model="editedItem.attachmentTypeValue.description"
              :disabled="true"
              :readonly="true"
              :aria-disabled="true"
              :aria-readonly="true"
              aria-describedby="input-2-live-feedback"
              required>
          </b-form-input>

        </b-form-group>

        <b-row style="margin-bottom:20px;">
          <b-col>
            <b-form-checkbox v-model="editedItem.required" name="active-switch" data-test="active-switch" switch>
              <b>Required?</b>
            </b-form-checkbox>
          </b-col>
        </b-row>

        <b-button type="button"  @click="close" style="margin-right:15px;">Cancel</b-button>
        <b-button type="button" :disabled="!isValid()" @click="save" variant="primary">Save</b-button>
      </form>

    </b-modal>

    <b-table hover small responsive show-empty
        :busy="loading"
        :items="attachmentReqs"
        :fields="fields"
        class="mt-2 mb-3"
    >
      <template v-slot:cell(actions)="row">
        <b-btn variant="primary" size="sm" @click="editItem(row.item)" >
          Edit
        </b-btn>
        <b-btn variant="danger" size="sm" @click="removeItem(row.item)">
          Remove
        </b-btn>
      </template>

      <template v-slot:cell(required)="{ item }">
        <div v-if="item.required===true">
          Yes
        </div>
        <div v-if="item.required===false">
          No
        </div>
      </template>
      
    </b-table>

  </div>
</template>

<script>
import axios from "axios"
import pageTitle from '@/mixins/pageTitle'


export default {
  title: 'Manage Attachments',

  data() {
    return {
      loading: false,
      attachmentReqs: [],
      attachmentTypes: [],
      otherAttachmentTypes: [],
      editedIndex: -1,
      requestOptions: {
        types: [],
        statuses: []
      },
      requestItem: {
        type: null,
        status: null
      },
      editedItem: {
        id: null,
        required: true,
        requestTypeValue: {
          code: null,
          description: null
        },
        attachmentTypeValue: {
          code: null,
          description: null
        },
        requestStatusValue: {
          code: null,
          description: null
        }
      },
      fields: [
        {key: "attachmentTypeValue.description", label: "Attachment Name", sortable: true},
        {key: "required", label: "Required?", sortable: true},
        "actions"
      ]
    }
  },

  created() {
    this.initialize()
  },

  mounted() {
    this.$root.$on('attachmentReqChange', () => {
      this.initialize()
      if (this.requestItem.type) {
        this.loadAttachmentReqs()
      }
    })
  },

  mixins: [
    pageTitle
  ],

  methods: {
    initialize() {
      this.loadRequestStatuses()
      this.loadRequestTypes()
      this.loadAttachmentTypes()
    },
    loadRequestStatuses() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/requeststatus`)
          .then(response => {
            this.requestOptions.statuses = response.data
          })
    },
    loadRequestTypes() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/requesttype`)
          .then(response => {
            this.requestOptions.types = response.data
          })
    },
    loadAttachmentReqs() {
      this.loading = true
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachment/requirements`, {
            typeCode: this.requestItem.type.code,
            statusCode: this.requestItem.status.code
          })
          .then(response => {
            this.attachmentReqs = response.data
            this.loading = false
            this.editedItem.requestTypeValue = this.requestItem.type
            this.editedItem.requestStatusValue = this.requestItem.status
            this.otherAttachmentReqs()
          })
    },
    loadAttachmentTypes() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachment/types`)
          .then(response => {
            this.attachmentTypes = response.data
          })
    },
    otherAttachmentReqs() {
      this.otherAttachmentTypes = []
      for (let i = 0; i < this.attachmentTypes.length; i++) {
        if (!this.attachmentReqs.some(e => e.attachmentTypeValue.code === this.attachmentTypes[i].code)) {
          this.otherAttachmentTypes.push(this.attachmentTypes[i])
        }
      }
    },
    editItem(item) {
      this.editedIndex = this.attachmentReqs.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.$bvModal.show('modal-crud')
    },
    removeItem(item) {
      if (confirm('Are you sure you want to delete this attachment requirement?\n\n' + item.attachmentTypeValue.description)) {
        axios.delete(`${process.env.VUE_APP_API_BASE_URL}/attachment/requirement/${item.id}`)
            .then(response => {
              this.$bvToast.toast('Attachment Requirement Removed', {
                title: 'Status',
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: 'success',
                appendToast: true
              })
              this.loadAttachmentReqs()
            })
      }
    },
    save () {
      let payload = {
        requestTypeValue: {},
        attachmentTypeValue: {},
        requestStatusValue: {}
      }
      payload.required = this.editedItem.required
      payload.requestTypeValue = this.editedItem.requestTypeValue
      payload.attachmentTypeValue = this.editedItem.attachmentTypeValue
      payload.requestStatusValue = this.editedItem.requestStatusValue
      if (this.editedIndex > -1) {
        payload.id = this.editedItem.id
        axios.put(`${process.env.VUE_APP_API_BASE_URL}/attachment/requirement`, payload)
            .then(response => {
              this.$bvToast.toast('Attachment Requirement Updated', {
                title: 'Status',
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: 'success',
                appendToast: true
              })
              this.loadAttachmentReqs()
            });
      } else {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachment/requirement`, payload)
            .then(response => {
              this.$bvToast.toast('Attachment Requirement Added', {
                title: 'Status',
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: 'success',
                appendToast: true
              })
              this.loadAttachmentReqs()
            });
      }
      this.close()
    },
    close () {
      this.$bvModal.hide('modal-crud')
      setTimeout(() => {
        this.editedItem.id = 0
        this.editedItem.required = true
        this.editedItem.requestTypeValue = {}
        this.editedItem.attachmentTypeValue = {}
        this.editedItem.requestStatusValue = {}
        this.editedIndex = -1
        this.loadRequestTypes()
      }, 300)
    },
    isValid() {
      if(this.editedItem.attachmentTypeValue.code &&
          this.editedItem.attachmentTypeValue.description) {
        return true
      } else
        return false
    }
  }
}
</script>

<style>

</style>